import { IMAGES } from './imagesActionTypes';

export const AddImages = (images) => ({

        type: IMAGES,
        payload: images

    }

)